import { memo } from "react";

interface HeaderIndicatorProps {
  color: string;
}

const HeaderIndicator = memo(({ color }: HeaderIndicatorProps) => (
  <div
    style={{
      position: "absolute",
      bottom: 0,
      left: "10%",
      width: "80%",
      height: "8px",
      overflow: "visible",
    }}
  >
    {/* Line only SVG */}
    <svg width="100%" height="2" preserveAspectRatio="none">
      <line x1="0" y1="1" x2="100%" y2="1" stroke={color} strokeWidth="2" />
    </svg>

    {/* Fixed-size arrow in a separate element */}
    <div
      style={{
        position: "absolute",
        width: "8px",
        height: "4px",
        left: "50%",
        transform: "translateX(-50%)",
      }}
    >
      <svg width="8" height="4" viewBox="0 0 8 4">
        <polygon points="4,4 0,0 8,0" fill={color} />
      </svg>
    </div>
  </div>
));

export default HeaderIndicator;
